import React, { Component } from 'react';
import { connectDeep } from 'redux-utils';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Content from './Content';
import Portal from 'components/Portal';
import { setModalShowing } from 'actions/gallery';

export * from './Common';

export const Container = styled.div`
  height: 100vh;
  position: absolute;
  top: 0;
  width: 100vw;
`;

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.4);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 65536;
`;

export const Modal = ({
  buttons,
  contentAbove,
  contentCenter,
  onClose,
  title
}) => (
  <Container>
    <Content
      buttons={buttons}
      contentAbove={contentAbove}
      contentCenter={contentCenter}
      title={title}
    />
    <Overlay onClick={onClose} />
  </Container>
);

Modal.propTypes = {
  onClose: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  setModalShowing: (showing) => dispatch(setModalShowing(showing))
});

export default connectDeep(
  null,
  mapDispatchToProps
)(
  class extends Component {
    componentDidMount() {
      this.props.setModalShowing(true);
    }

    componentWillUnmount() {
      this.props.setModalShowing(false);
    }

    render() {
      const { id, ...modalProps } = this.props;

      return <Portal id={id} content={<Modal {...modalProps} />} />;
    }
  }
);
